"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useTheme = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = require("@fluentui/react");

var _react2 = require("react");

var useTheme = function useTheme() {
  var themeOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = (0, _react2.useState)((0, _react.getTheme)()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  (0, _react2.useEffect)(function () {
    (0, _react.registerOnThemeChangeCallback)(setTheme);
    return function () {
      return (0, _react.removeOnThemeChangeCallback)(setTheme);
    };
  }, [themeOverrides]);
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, theme), themeOverrides);
};

exports.useTheme = useTheme;